var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"mask"},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container loading6"},[_c('div',{staticClass:"shape shape1"}),_c('div',{staticClass:"shape shape2"}),_c('div',{staticClass:"shape shape3"}),_c('div',{staticClass:"shape shape4"})])
}]

export { render, staticRenderFns }